<template>
  <b-row>
    <b-col cols="12">
      <Search
        :title="'لیست پرونده ها'"
        :allowFields="$lang.report_parvandeh_list_allow_fields"
        :url="parvandehListUrl"
        :visibleExport="false"
        :visibleFilters="true"
        :showFilterBtn="true"
        :visibleViewCount="false"
        :visibleAdd="false"
        :allowEdit="false"
        :allowOperate="false"
        :filterCatch="true"
        :showTotals="true"
        :showCheckBox="true"
        :showRowAllSelected="false"
        :handleCheckBoxCondition="() => true"
        @rowSelected="handleRowSelect"
      />
    </b-col>
    <b-col cols="12" class="mt-3 d-flex align-items-center justify-content-end">
      <b-button variant="outline-danger" class="mr-2" @click="close">
        <mdicon name="close" size="24" />
        {{ $lang.close }}
      </b-button>
      <b-button variant="success" class="d-flex" @click="getData">
        <mdicon
          v-if="loading"
          name="loading"
          size="24"
          class="spinner center"
        />
        <mdicon v-else name="check" size="24" />
        <span class="ml-1">{{ $lang.submitButton }}</span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import Search from "@/components/base/search.vue";
import useServices from "./dependencies/useServices";
import { computed, inject, ref } from "vue";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: { Search },
  setup() {
    const parvandehListUrl = computed(() =>
      generateApiUrl(["report", "company_parvandeh_report"])
    );

    // generate select parvandeh
    const selectedItems = ref([]);
    const handleRowSelect = (item, callback) => {
      const code = pathOr(null, ["parvandeh", "code"], item);
      const parvandehNumber = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      const fullName = pathOr("", ["parvandeh", "person", "full_name"], item);
      const image = pathOr("", ["parvandeh", "person", "img"], item);
      const termCaption = pathOr("", ["term", "caption"], item);
      const finalItem = {
        code,
        parvandehNumber,
        fullName,
        image,
        termCaption,
      };

      const alreadyExist = selectedItems.value.some((row) => row.code === code);
      if (alreadyExist) {
        selectedItems.value = [
          ...selectedItems.value.filter((row) => row.code !== code),
        ];
      } else {
        selectedItems.value.push(finalItem);
      }
    };

    const close = inject("close");

    // get services of external file
    const { loading, getData } = useServices(selectedItems.value);

    // return data to be used in template
    return {
      parvandehListUrl,
      handleRowSelect,
      close,
      loading,
      getData,
      selectedItems,
    };
  },
};
</script>
